"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Dropdown = _interopRequireDefault(require("../Dropdown.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_Dropdown["default"]); // eslint-disable-line


function Item(props) {
  var children = props.children,
      multipleActions = props.multipleActions,
      propClasses = props.className,
      attrs = _objectWithoutProperties(props, ["children", "multipleActions", "className"]);

  var className = cx('dropdown__list-item', {
    'dropdown__list-item--actions': multipleActions
  });
  return /*#__PURE__*/_react["default"].createElement("li", _extends({
    className: "".concat(className, " ").concat(propClasses)
  }, attrs), children);
}

Item.displayName = 'Item';
Item.propTypes = {
  /** HTML Node that will appear in the component */
  children: _propTypes["default"].node,

  /** A prop to allow style customization * */
  className: _propTypes["default"].string,

  /** Flag to control if the item has multiple buttons - if true it will add extra CSS */
  multipleActions: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming

  /** Event handler when the item is clicked */
  onClick: _propTypes["default"].func
};
Item.defaultProps = {
  children: null,
  className: '',
  onClick: null,
  multipleActions: false
};
var _default = Item;
exports["default"] = _default;